import { getAPIAxios } from "../../../../../helper/constants/uri";
import { DateTime } from "luxon";

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const checkStripeUpdate = async (maxCount = 5) => {

    let counter = 0;

    await timeout(400);

    while(counter < maxCount) {
        const axios = getAPIAxios();
        const lastRes = await axios.get("/stripe/last-info");
        const res = lastRes.data;

        const date = DateTime.fromISO(res.transactionDate);
        const difference = Math.abs( date.diffNow('seconds').seconds );

        if (difference < 30) {
            return res;
        }

        await timeout(1300);

        counter++;
    }

    return null;
}
